import { Action, createReducer, on } from '@ngrx/store';
import { SearchCoordinates, Company } from '@warema/shared/models';
import * as SearchActions from './search.actions';

export interface SearchState {
    companies: Array<Company>;
    selectedCompanyId: string | null;
    toggleInstatOffer: boolean;
    noSearchResults: boolean | null;
    isSearchRunning: boolean;
    latestSearchedCoordinates: SearchCoordinates;
    canSearchMore: boolean;
}

const initialState: SearchState = {
    companies: [],
    selectedCompanyId: null,
    toggleInstatOffer: false,
    noSearchResults: null,
    isSearchRunning: false,
    canSearchMore: false,
    latestSearchedCoordinates: { address: '', latitude: 0, longitude: 0 },
};

export const searchReducer = createReducer(
    initialState,

    on(SearchActions.CompaniesSearched, (state, { companies }): SearchState => {
        return { ...state, companies };
    }),

    on(SearchActions.MoreCompaniesSearched, (state, { companies }): SearchState => {
        const result = [...state.companies, ...companies];
        return { ...state, companies: result };
    }),

    on(SearchActions.CompanySelected, (state, { id }): SearchState => {
        return { ...state, selectedCompanyId: id };
    }),

    on(SearchActions.InstantOfferToggled, (state, { instantOffer }): SearchState => ({
        ...state,
        toggleInstatOffer: instantOffer,
    })),

    on(SearchActions.isSearchRunningStatusChanged, (state, { isSearchRunning }): SearchState => {
        return { ...state, isSearchRunning };
    }),

    on(SearchActions.noSearchResultsChanged, (state, { noSearchResults }): SearchState => {
        return { ...state, noSearchResults };
    }),

    on(SearchActions.canSearchMoreChanged, (state, { canSearchMore }): SearchState => {
        return { ...state, canSearchMore };
    }),

    on(SearchActions.searchCoordinatesChanged, (state, { searchCoordinates }): SearchState => {
        return { ...state, latestSearchedCoordinates: searchCoordinates };
    }),

    on(SearchActions.clearCompanySearchDataExceptLocationAndInstantOffer, (state): SearchState => {
        return {
            ...state,
            companies: [],
            selectedCompanyId: null,
            canSearchMore: false,
            noSearchResults: null,
            isSearchRunning: false,
        };
    }),

    on(SearchActions.clearCompanySearchData, (state): SearchState => {
        return {
            ...state,
            companies: [],
            selectedCompanyId: null,
            canSearchMore: false,
            noSearchResults: null,
            isSearchRunning: false,
            toggleInstatOffer: false,
            latestSearchedCoordinates: { address: '', latitude: 0, longitude: 0 },
        };
    }),

    on(SearchActions.SpecificCompanyAutoSelected, (state, { company }): SearchState => {
        return { ...state, companies: [company], selectedCompanyId: company.addressId };
    }),
);

export function reducer(state: SearchState | undefined, action: Action): SearchState {
    return searchReducer(state, action);
}
